import {AppService} from "@/service/app.service";
import {AxiosService} from "@/service/axios.service";
import {KRBS_CIRCULARS} from "@/config/constants.config";
import {AlertService} from "@/service/alert.service";
import {toLower} from "lodash";

const state={
}

const mutations={
}

const actions={
    addAttachment({commit},params){
       return  AxiosService.post(KRBS_CIRCULARS.CIRCULAR_ATTACHMENTS.ADD,params).then(r=>{
           commit('SET_UPDATED_CIRCULAR',r.data.data.data)
            return r.data.data;
        }).catch(err=>{
            AlertService.responseAlertMessage(err,'ADD ATTACHMENT')
            return AlertService.parseErrors(err.response.data.errors);
        });
    },
    updateAttachment({commit},params){
        return  AxiosService.post(KRBS_CIRCULARS.CIRCULAR_ATTACHMENTS.UPDATE,params).then(r=>{
            commit('SET_UPDATED_CIRCULAR',r.data.data.data)
            return r.data.data;
        }).catch(err=>{
            AlertService.responseAlertMessage(err,'UPDATE ATTACHMENT')
            return AlertService.parseErrors(err.response.data.errors);
        });
    },
    deleteCircularAttachment({commit},circular_attachment_id){
        return  AxiosService.post(KRBS_CIRCULARS.CIRCULAR_ATTACHMENTS.DELETE,{id:circular_attachment_id}).then(r=>{
            commit('SET_UPDATED_CIRCULAR',r.data.data.data)
            return r.data.data.data;
        }).catch(err=>{
            AlertService.responseAlertMessage(err,'ADD ATTACHMENT')
            return AlertService.parseErrors(err.response.data.errors);
        });
    },
    async getCircularAttachmentFile({commit,rootState},circular_attachment){
        let userType=toLower(rootState.AuthModule.authUser.scope);
        return AxiosService.get(`${userType}/circular_attachments/${circular_attachment}/file`).then(res=>{
            return res.data.data ? res.data.data : [];
        }).catch(e=>{
            AlertService.responseAlertMessage(e,'VIEW CIRCULAR ATTACHMENT FILE');
            return AlertService.parseErrors(e.response.data.errors);
        })
    },
    async getZipFile({commit,rootState},circular){
        let userType=toLower(rootState.AuthModule.authUser.scope);
        return AxiosService.get(`${userType}/circular_attachments/${circular}/zip`).then(res=>{
            return res.data.data ? res.data.data : [];
        }).catch(e=>{
            AlertService.responseAlertMessage(e,'VIEW CIRCULAR FILE');
            return AlertService.parseErrors(e.response.data.errors);
        })
    },

    async getCircularFileAttachmentOnSearch({commit,rootState}, params){
        let userType=toLower(rootState.AuthModule.authUser.scope);
        return AxiosService.get(`${userType}/circularAttachmentSearch/attachment/file`, params).then(res=>{
            return res.data.data ? res.data.data : [];
        }).catch(e=>{
            AlertService.responseAlertMessage(e,'VIEW CIRCULAR ATTACHMENT FILE ON SEARCH');
            return AlertService.parseErrors(e.response.data.errors);
        })
    },

}

const getters={

}

export default {state,getters,mutations,actions}